@if((search.value === '' && singleSelect.value === '') || (!search.value && !singleSelect.value)){
  <span class="placeholder">
    {{ placeholder ?? "Select " + (label ?? "value") }}
  </span>
}
@else if(singleSelect.value){
  <span class="selected-value">{{singleSelect.value}}</span>
}

<input
  *ngIf="isSearch"
  class="input"
  type="text"
  id="{{ inputId }}"
  [name]="name"
  autocomplete="off"
  [formControl]="search"
/>

<input
  *ngIf="!isSearch"
  class="input single-select"
  type="button"
  id="{{ inputId }}"
  [name]="name"
  [formControl]="singleSelect"
/>
